import React from 'react'

import { ChevronLeft, ChevronRight } from 'lucide-react'

export default function FormNavigation({ step, totalSteps, errorFields, onBack, onNext }) {
  if (step >= totalSteps) return null
  return (
    <div className="form-navigation">
      {errorFields.length > 0 && step < totalSteps - 1 && (
        <div className="form-navigation__error">
          Please complete the required fields before proceeding.
        </div>
      )}
      <div className="form-navigation__buttons">
        <button
          type="button"
          onClick={onBack}
          disabled={step === 0}
          className="form-navigation__button form-navigation__button--back"
        >
          <ChevronLeft size={20} />
          <span>Back</span>
        </button>
        {step < totalSteps - 1 && (
          <button
            type="button"
            onClick={onNext}
            className="form-navigation__button form-navigation__button--next"
          >
            <span>
              Next{totalSteps - step - 1 > 0 ? ` (${totalSteps - step - 1})` : ''}
            </span>
            <ChevronRight size={20} />
          </button>
        )}
      </div>
    </div>
  )
}